export enum XDocCreateShipmentInputId {
  vehicleNumber = 'vehicleNumber',
  isReturn = 'isReturn',
  nextDropOffPointId = 'nextDropOffPointId',
}

export type XDocCreateShipmentMap = {
  [XDocCreateShipmentInputId.vehicleNumber]: string;
  [XDocCreateShipmentInputId.isReturn]: boolean;
  [XDocCreateShipmentInputId.nextDropOffPointId]: string;
};

export type ICreateXDocCreateShipmentInitData = {
  [K in keyof XDocCreateShipmentMap]: XDocCreateShipmentMap[K];
};

export const initCreateShipmentData = {
  [XDocCreateShipmentInputId.vehicleNumber]: '',
  [XDocCreateShipmentInputId.isReturn]: false,
  [XDocCreateShipmentInputId.nextDropOffPointId]: '',
} satisfies ICreateXDocCreateShipmentInitData;
